











































import Vue from "vue";
import Api from "../../base/api.typings";
import Component from "vue-class-component";
import servicoService from '../servico/servico-service';
import routerService from '../../base/router-service';
import empresaAtualService from '../../features/empresa-atual/empresa-atual-service';
import authService from '../../features/api-authorization/authorize-service';    

@Component
export default class ChamadoAbrir extends Vue {

    async created() {
        this.empresaAtual = await empresaAtualService.obterEmpresaAtualId();
        if (this.empresaAtual != null) {
            this.listarServicoGrupos();
        }
    }

    servicoGrupos: Api.App.Server.Servico.ListarServicoGrupos.Dto[] = [];

    get carregando() {
        return !this.servicoGrupos;
    }

    tipoChamado: string = window.location.pathname;

    empresaAtual: string = null;

    async logout() {
        if (this.empresaAtual == null) {
            await authService.signOut({ returnUrl: location.origin });
        }
    }

    async abrirChamado(servicoGrupoId: number) {
        if (this.tipoChamado == "/chamado/abrir") {
            await routerService.goTo('chamado-registrar', { servicoGrupoId })
        } else {
            await routerService.goTo('chamado-recorrente-inserir', { servicoGrupoId })
        };
    }

    async listarServicoGrupos() {
        let resultado = await servicoService.listarServicoGrupos({
        });

        this.servicoGrupos = resultado.itens;
    }        
}
